import { equals } from 'ramda';
import React, { useEffect, useState } from 'react';

import { YearRangeFilter } from '../../../generated/model/yearRangeFilter';
import { useOnChange } from '../../../hooks/useOnChange';
import ReadableStatementView from '../../Inputs/ReadableStatementView';
import SwitchCompaniesUnknowns from '../../Inputs/SwitchCompaniesUnknowns';
import YearRange from '../../Inputs/YearRange';
import { allowedYearRange } from '../../Inputs/YearRange/YearRange';

interface Props {
  root?: boolean;
  withUnknownSwitch?: boolean;
  unknownSwitchEnabled?: boolean;
  field?: string;
  onChange: (state: YearRangeFilter) => void;
  defaultAllowedYearRange?: typeof allowedYearRange;
  defaultValue?: YearRangeFilter;
  active: boolean;
}

const YearRangePickerFilterInput: React.FC<Props> = React.memo(
  ({
    onChange,
    field,
    withUnknownSwitch = false,
    unknownSwitchEnabled,
    root,
    active,
    defaultAllowedYearRange = allowedYearRange,
    defaultValue = withUnknownSwitch
      ? {
          includeEmpty: unknownSwitchEnabled === undefined ? true : unknownSwitchEnabled,
          value: defaultAllowedYearRange,
        }
      : { value: defaultAllowedYearRange },
  }) => {
    const [state, setState] = useState<YearRangeFilter>(defaultValue);
    useOnChange(onChange, state, root);
    useEffect(() => {
      if (!equals(defaultValue, state)) {
        setState(defaultValue);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue]);

    const rs: any[] = [];
    if (withUnknownSwitch && state.includeEmpty) {
      rs.push({ label: 'Included:', value: 'Companies with unknown data' });
    }
    if (state.value?.from && state?.value?.to) {
      rs.push({ label: 'Range:', value: `From ${state.value.from} to ${state.value.to}` });
    }

    return (
      <>
        {active ? (
          <>
            {withUnknownSwitch && (
              <SwitchCompaniesUnknowns
                onChange={(value) => {
                  setState({ ...state, includeEmpty: value });
                }}
                checked={state.includeEmpty}
              />
            )}
            <YearRange
              root={root}
              field={field}
              defaultValue={{
                from: state?.value?.from,
                to: state?.value?.to,
              }}
              defaultAllowedYearRange={defaultAllowedYearRange}
              onChange={(range) => {
                setState({
                  ...state,
                  value: { from: range.from, to: range.to },
                });
              }}
            />
          </>
        ) : (
          <ReadableStatementView rows={rs} />
        )}
      </>
    );
  },
);

export default YearRangePickerFilterInput;
